<template>
  <div v-if="recommendData.length > 0" class="product-photos__featured">
    <h5>MORE LOOK</h5>
    <div class="product-photos__slider">
      <div v-for="item in recommendData" :key="item.url">
        <a :href="item.url">
          <!-- <img class="img-fluid" src="https://via.placeholder.com/868x1112/0000FF/808080" alt="" /> -->
          <new-image :url="item.image" size="_w310_h389" />
        </a>
        <h3 class="recommend-product-name">{{ item.name }}</h3>
        <div v-if="item.originPrice" class="recommend-product-price">
          <p class="sell-price">
            NT${{ item.eventPrice > 0 && item.eventPrice &lt; item.sellPrice ? item.eventPrice : item.sellPrice }}
          </p>
          <p
            v-if="item.sellPrice !== item.originPrice && item.eventPrice === 0"
            class="origin-price"
          >
            NT${{ item.originPrice }}
          </p>
          <p v-else-if="item.eventPrice > 0" class="origin-price">NT${{ item.sellPrice }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewImage from '@global/components/global/image';
import { getShopRecommend } from '@global/helpers/recommend';
import $ from 'jquery';
import {
  fireRecommendByCategoryClickEvent,
  fireRecommendViewGAEventByCategory,
} from '@global/gtm/product';

require('@global/vendors/slick');

export default {
  name: 'ProductRecommend',
  components: { NewImage },
  props: {
    productName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      slideOptions: {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        mobileFirst: true,
        dots: false,
        arrows: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      },
      recommendData: [],
    };
  },
  watch: {
    recommendData(data) {
      if (data.length !== 0) {
        fireRecommendViewGAEventByCategory({
          itemListName: `${window.CustomMarketID.split('SZ')[0]} 用戶推薦產品列表`,
          recommendData: this.recommendData,
        });

        this.$nextTick(() => {
          $('.product-photos__slider').not('.slick-initialized').slick(this.slideOptions);

          $('.product-photos__slider').on('swipe', (event, slick, direction) => {
            fireRecommendByCategoryClickEvent({
              recommendedData: this.recommendData,
              recommendedMove:
                direction === 'left' ? '推薦商品 More 左箭頭' : '推薦商品 More 右箭頭',
              recommendedType: '產品內頁',
              productId: window.CustomMarketID,
              productName: this.productName,
              itemListName: '品牌推薦產品列表',
            });
          });

          $('.product-photos__slider .slick-prev').on('click', () => {
            fireRecommendByCategoryClickEvent({
              recommendedData: this.recommendData,
              recommendedMove: '推薦商品 More 左箭頭',
              recommendedType: '產品內頁',
              productId: window.CustomMarketID,
              productName: this.productName,
              itemListName: '品牌推薦產品列表',
            });
          });

          $('.product-photos__slider .slick-next ').on('click', () => {
            fireRecommendByCategoryClickEvent({
              recommendedData: this.recommendData,
              recommendedMove: '推薦商品 More 右箭頭',
              recommendedType: '產品內頁',
              productId: window.CustomMarketID,
              productName: this.productName,
              itemListName: '品牌推薦產品列表',
            });
          });
        });
      }
    },
  },
  created() {
    getShopRecommend().then((recommendData) => {
      this.recommendData = recommendData;
    });
  },
};
</script>
